import React from 'react';
import { message, Tooltip } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { formatUserLocalDate3 } from '@utils/widget';
import alert from '@components/alert';
import ProjectRoleTooltip from '@components/projectRoleTooltip/ProjectRoleTooltip';

const formatDateTime = (date) => {
  if (!date) {
    return '-';
  }
  return formatUserLocalDate3(date);
};

export const tableColumns = ({
  projectRoleOptions,
  editInfo,
  setEditInfo,
  memberData,
  handleRemove,
  remove,
  matchGroups,
  copyAllEmails,
}) => [
  {
    title: 'Role Permission',
    dataIndex: 'permission',
    editable: true,
    inputType: 'select',
    key: 'permission',
    width: '12%',
    render: (permission) => (
      <span>
        {projectRoleOptions.find((item) => item.value === permission)?.label}
      </span>
    ),
  },
  {
    title: 'Email',
    dataIndex: 'email',
    editable: true,
    inputType: 'userSelect',
    key: 'email',
    width: '20%',
  },
  {
    title: 'Name',
    dataIndex: 'fullName',
    key: 'fullName',
    width: '12%',
  },
  {
    title: (
      <>
        Project Role&ensp;
        {ProjectRoleTooltip}
      </>
    ),
    dataIndex: 'role_name',
    editable: true,
    inputType: 'select',
    key: 'role_name',
    width: '15%',
  },
  {
    title: () => (
      <div>
        EU Based&ensp;
        <Tooltip
          title={
            <div className="eu-based-tooltip">
              To comply with GDPR Requirements, please check the box for EU
              Based users. Visit our{' '}
              <a href="/gateway/privacy" target="_blank">
                Privacy Policy
              </a>{' '}
              for more information.
            </div>
          }
        >
          <span className="appkiticon icon-information-fill" />
        </Tooltip>
      </div>
    ),
    dataIndex: 'isEUBased',
    editable: true,
    inputType: 'checkbox',
    key: 'isEUBased',
    width: '10%',
    align: 'center',
    render: (_, record, index) =>
      memberData?.[index]?.isEUBased ? <CheckOutlined /> : '',
    // return (
    //   <Checkbox
    //     checked={memberData?.[index]?.isEUBased || false}
    //     className={'eu-disabled'}
    //   />
    // )
  },
  {
    title: 'Last Visit',
    dataIndex: 'lastVisit',
    key: 'lastVisit',
    width: '15%',
    sorter: (a, b) =>
      new Date(b.lastVisit).getTime() - new Date(a.lastVisit).getTime(),
    render: (_, record) => formatDateTime(record.lastVisit),
  },
  {
    title: (
      <span onClick={copyAllEmails} className="pointer-cursor">
        Copy All Emails
      </span>
    ),
    dataIndex: 'name',
    key: 'name',
    width: '8%',
    render: (email, record) => (
      <span
        style={{ position: 'relative', top: 3 }}
        className="appkiticon icon-duplicate-outline a-font-24"
        onClick={() => {
          message.destroy();
          navigator.clipboard.writeText(record.email);
          message.success('Email address copied!');
        }}
      />
    ),
  },
  // {
  //   title: 'Action',
  //   dataIndex: 'action',
  //   key: 'action',
  //   render: (_, record = {}, index) => (
  //     <div>
  //       {editInfo?.index === index ? null : (
  //         <a
  //           style={{ marginRight: 16 }}
  //           onClick={() => {
  //             const editInfo = {
  //               ...record,
  //               index,
  //             };
  //             setEditInfo(editInfo);
  //           }}
  //         >
  //           Edit
  //         </a>
  //       )}
  //       {editInfo?.index === index
  //         ? null
  //         : index > 0 && (
  //             <a
  //               onClick={() => {
  //                 alert.confirm({
  //                   content: (
  //                     <>
  //                       {memberData[index]?.fullName} will be removed from below
  //                       groups after deletion.
  //                       <br />
  //                       {matchGroups(index).map((group) => (
  //                         <>
  //                           · {group}
  //                           <br />
  //                         </>
  //                       ))}
  //                     </>
  //                   ),
  //                   okText: 'Remove',
  //                   onOk: handleRemove(remove, record.name, index),
  //                 });
  //               }}
  //             >
  //               Delete
  //             </a>
  //           )}
  //     </div>
  //   ),
  // },
];
